import { render, staticRenderFns } from "./Bullets.vue?vue&type=template&id=39e77fc3&"
import script from "./Bullets.vue?vue&type=script&lang=js&"
export * from "./Bullets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports